"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateUtils = void 0;
const moment_1 = __importDefault(require("moment"));
const format = (dateString, dateFormat = "DD/MM/YYYY") => {
    if (!dateString)
        return null;
    return (0, moment_1.default)(dateString).format(dateFormat);
};
const now = () => new Date();
const today = () => (0, moment_1.default)().format("YYYY-MM-DD");
exports.dateUtils = {
    format,
    now,
    today,
};
//# sourceMappingURL=dateUtils.js.map